import React from "react";
import { GatsbyBrowser } from "gatsby";
import { LayoutContextProvider } from "@utilities";
import { Helmet } from "react-helmet";

const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ( { element } ) => {
    return (
        <LayoutContextProvider>
            <Helmet htmlAttributes={ { lang: 'en-US', } }/>
            { element }
        </LayoutContextProvider>
    )
}

export default wrapRootElement
